import "./customers.css"
import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import logoCustomersPT from "../../imagens/logos/logoCustomers.png"
import logoCustomersEN from "../../imagens/logos/logoCustomers.png"
import { useTranslation } from "react-i18next"

function Customers({ listCustomer }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const { i18n } = useTranslation()
    const language = i18n.language

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listCustomer.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listCustomer.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listCustomer.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listCustomer.length])
    
    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break
                case 'ArrowRight':
                    nextSlide()
                    break
                default:
                    break
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);


    return (
        <div>
            {/* Modal */}
            {openModal &&
                <div className='customerSliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="customerBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="customerBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="customerBtnClose" onClick={() => handleCloseModal()} />
                    <img className='customerFullScreenImage' src={listCustomer[slideNumber].img} alt='customerImg' />
                </div>
            }

            {/* Logo PT / EN */}
            <div>
                <img
                    className='img-custom-size img-fluid ms-2'
                    src={language === "en" ? logoCustomersEN : logoCustomersPT}
                    alt='logoCustomer'
                />
            </div>

            {/* Gallery */}
            <div className="customerGalleryWrap mx-2">
                {listCustomer && listCustomer.map((image, index) => (
                    <div
                        className="customerSingle"
                        key={index}
                        onClick={() => handleOpenModal(index)}
                    >
                        <img src={image.img} alt="CustomersImg"/>
                    </div>
                ))}
            </div>

            {/* Back Button PT/EN */}
            <div className="text-center text-nowrap my-4">
                <Link to="/">
                    <button className="buttonCapabilities">
                        {language === "en" ? "Back to Home" : "Voltar ao início"}
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default Customers
